/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestTehtrisConnectionRequest
 */
export interface TestTehtrisConnectionRequest {
    /**
     * Optional new API key to test (uses stored key if not provided)
     */
    apiKey?: string;
    /**
     * Optional region to test (uses stored region if not provided)
     */
    region?: TestTehtrisConnectionRequestRegionEnum;
}


/**
 * @export
 */
export const TestTehtrisConnectionRequestRegionEnum = {
    Xjc: 'xjc',
    Xjd: 'xjd',
    Xje: 'xje',
    Xjf: 'xjf',
    Xjg: 'xjg',
} as const;
export type TestTehtrisConnectionRequestRegionEnum = typeof TestTehtrisConnectionRequestRegionEnum[keyof typeof TestTehtrisConnectionRequestRegionEnum];


/**
 * Check if a given object implements the TestTehtrisConnectionRequest interface.
 */
export function instanceOfTestTehtrisConnectionRequest(value: object): value is TestTehtrisConnectionRequest {
    return true;
}

export function TestTehtrisConnectionRequestFromJSON(json: any): TestTehtrisConnectionRequest {
    return TestTehtrisConnectionRequestFromJSONTyped(json, false);
}

export function TestTehtrisConnectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestTehtrisConnectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
        'region': json['region'] == null ? undefined : json['region'],
    };
}

export function TestTehtrisConnectionRequestToJSON(json: any): TestTehtrisConnectionRequest {
    return TestTehtrisConnectionRequestToJSONTyped(json, false);
}

export function TestTehtrisConnectionRequestToJSONTyped(value?: TestTehtrisConnectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'apiKey': value['apiKey'],
        'region': value['region'],
    };
}

